import { Breadcrumb } from 'antd';
import { DiffOutlined } from '@ant-design/icons';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { capitalizeFirstLetter } from '../lib/utils';

interface PageHeaderActionProps {
  moduleName: string;
  action: string | undefined | null;
}
const PageHeaderAction: React.FC<PageHeaderActionProps> = ({
  moduleName,
  action,
}) => {
  const navigate = useNavigate();
  const [isNavigating, setIsNavigating] = useState(false);
  const handleGoBack = () => {
    if (!isNavigating) {
      setIsNavigating(true);
      navigate(-1);
    }
  };

  return (
    <>
      <div className={'flex items-center justify-between'}>
        <Breadcrumb
          items={[
            {
              title: (
                <>
                  <DiffOutlined />
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      handleGoBack();
                    }}
                  >
                    <span>{moduleName}</span>
                  </a>
                </>
              ),
            },
            {
              title: capitalizeFirstLetter(action),
            },
          ]}
        />
      </div>
    </>
  );
};

export default PageHeaderAction;
